$(document).ready(function () {
  const $slider = $(".st-qa-slider");
  const $prevBtn = $(".st-qa-slider-arrow--prev");
  const $nextBtn = $(".st-qa-slider-arrow--next");
  const totalSlides = () => $slider.slick("getSlick").slideCount;


  // 1) Init Slick with arrows: false
  $slider.slick({
    arrows: false,
    dots: false,
    slidesToShow: 1,
    autoplay: false,
    infinite: false,
    speed: 700,
    swipe: false,
    adaptiveHeight: true,
  });

  // Function to validate current slide
  function validateCurrentSlide() {
    const $currentSlide = $slider.find(".slick-current");
    let isValid = true;

    // Check radio buttons (including those with data-name)
    $currentSlide.find("input[type='radio'][required]").each(function () {
      const dataName = $(this).data("name");
      const name = $(this).attr("name");
      const selector = dataName
        ? `input[type='radio'][data-name='${dataName}']`
        : `input[type='radio'][name='${name}']`;

      const $radios = $currentSlide.find(selector);
      const $checked = $radios.filter(":checked");

      if ($checked.length === 0) {
        isValid = false;
        $radios
          .closest(".st-checkbox-container, .st-selectable-box")
          .addClass("error");
      } else {
        $radios
          .closest(".st-checkbox-container, .st-selectable-box")
          .removeClass("error");
      }
    });

    // Check checkboxes (only those with data-name for groups)
    $currentSlide.find("input[type='checkbox'][required]").each(function () {
      const dataName = $(this).data("name");
      if (!dataName) return; // Skip if no data-name attribute

      const $checkboxes = $currentSlide.find(
        `input[type='checkbox'][data-name='${dataName}']`
      );
      const $checked = $checkboxes.filter(":checked");

      if ($checked.length === 0) {
        isValid = false;
        $checkboxes.closest(".st-checkbox-container").addClass("error");
      } else {
        $checkboxes.closest(".st-checkbox-container").removeClass("error");
      }
    });

    $currentSlide
      .find(
        "input[type='text'][required], input[type='url'][required], textarea[required], select[required], input[type='email'][required]"
      )
      .each(function () {
        const $input = $(this);
        const isEmail = $input.attr("type") === "email";
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex for email validation

        if (isEmail && !emailPattern.test($input.val().trim())) {
          isValid = false;
          $input.addClass("error");
        } else if (!isEmail && (!$(this).val() || !$(this).val().trim())) {
          isValid = false;
          $input.addClass("error");
        } else {
          $input.removeClass("error");
        }
      });

    return isValid;
  }

  // Function to update progress bar
  function updateProgressBar(slick, currentSlide) {
    const totalSlides = slick.slideCount;
    const progressPercentage = ((currentSlide + 1) / totalSlides) * 100;
    $(".st-qa-slider-progress").css("width", progressPercentage + "%");
  }

  // 2) Common routine to show/hide custom buttons
  function updateArrows(current) {
    // hide "prev" on the very first slide
    $prevBtn.toggle(current > 0);
    // hide "next" on the very last slide
    // $nextBtn.toggle(current < totalSlides() - 1);
  }

  // 3) Set initial state
  const slickInst = $slider.slick("getSlick");
  updateArrows(slickInst.currentSlide);
  updateProgressBar(slickInst, slickInst.currentSlide);

  // 4) Whenever the slide changes, update both progress bar & arrows
  $slider.on("afterChange", function (e, slick, currentSlide) {
    updateProgressBar(slick, currentSlide);
    updateArrows(currentSlide);
  });

  // 5) Wire up Prev button
  $prevBtn.on("click", function () {
    $slider.slick("slickPrev");
    // Scroll to the top of the form
    $("html, body").animate({ scrollTop: $("#st-qa-form").offset().top }, 500);
  });

  // 6) Wire up Next button with validation
  $nextBtn.on("click", function (e) {
    e.preventDefault();

    if (validateCurrentSlide()) {
      const currentSlide = $slider.slick("slickCurrentSlide");
      const totalSlides = $slider.slick("getSlick").slideCount;

      // If we're on the last slide, submit the form
      if (currentSlide === totalSlides - 1) {
        $("#st-qa-form").submit();
      } else {
        $slider.slick("slickNext");
        // Scroll to the top of the form
        $("html, body").animate(
          { scrollTop: $("#st-qa-form").offset().top },
          500
        );
      }
    } else {
      // Show error message or visual feedback
      const $currentSlide = $slider.find(".slick-current");
      $currentSlide.addClass("shake");
      setTimeout(() => {
        $currentSlide.removeClass("shake");
      }, 500);
    }
  });

  // Toggle Text‐Field
  $("input.color-field-01, input.color-field-02").on(
    "change",
    function handleColorOtherToggle() {
      const $group = $(this).closest(".st-color-group");
      const $other = $group.find(".st-color-group__other-input");

      if (this.value === "andere") {
        $other.show().find("input").prop("required", true);
      } else {
        $other.hide().find("input").prop("required", false).val("");
      }
    }
  );

  $(".st-color-group__other-input").hide();

  // Show/hide optional FuPa-Link field on "JA" toggle
  $('input[data-name="vereinswappen"]').on("change", function () {
    const isYes = $('input[data-name="vereinswappen"][value="ja"]').is(
      ":checked"
    );
    $(".st-qa-slide__info-text").toggle(isYes);
  });

  // Show/hide offenes Textfeld für "reference" bei JA
  $('input[data-name="reference"]').on("change", function () {
    let $field = $(".st-qa-slide__field--reference");
    const yesChecked = $('input[data-name="reference"][value="ja"]').is(
      ":checked"
    );
    if (yesChecked) {
      $field.addClass("jr-show");
      $field.find("textarea").prop("required", true);
    } else {
      $field.removeClass("jr-show");
      $field.find("textarea").prop("required", false);
    }
  });

  // Toggle Sponsor-URL fields
  $('input[value="brustsponsor"]').on("change", function () {
    const $field = $(".sponsor-brust");
    if (this.checked) {
      $field.toggleClass("jr-show");
      $field.find("input").prop("required", true);
    } else {
      $field.toggleClass("jr-show");
      $field.find("input").prop("required", false);
    }
  });

  $('input[value="armelsponsor"]').on("change", function () {
    const $field = $(".sponsor-armel");
    if (this.checked) {
      $field.toggleClass("jr-show");
      $field.find("input").prop("required", true);
    } else {
      $field.toggleClass("jr-show");
      $field.find("input").prop("required", false);
    }
  });


});
